import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding-top: 40px;
  position: relative;
`;

export const MiddleCol = styled.div`
  padding: 0 16px;
  flex-grow: 1;
`;
